import React, { Component }                 from 'react';
import ReactTable                           from 'react-table';
import urlHandler                           from '../../utils/urlHandler';
import perms                                from '../../utils/permissions';
import CustomEntityDataControl              from './CustomEntityDataControl';
import CustomRegExDataControl               from './CustomReExDataControl';
import CreateCustomEntity                   from './CustomEntityCreateDialog';
import CreateRegexEntity                    from './RegExEntityCreateDialog';
import { customEntityDeleteDialog }         from './CustomEntityDeleteDialog';
import { customRegExDeleteDialog }          from './CustomRegExDeleteDialog';
import UserManual                           from '../../styles/docs/FFT_DemoUserGuide.pdf';
import {Link}                               from 'react-router-dom';
import history                              from '../../utils/history';

import 'react-table/react-table.css'

class KnowledgebaseControl extends Component {
    constructor(props){
        super(props);

        this.onSelectResult = this.onSelectResult.bind(this);
        this.onResultsChange = this.onResultsChange.bind(this);
        // this.onEdit = this.onEdit.bind(this);
        this.onCreate = this.onCreate.bind(this);
        this.onCreateCompleted = this.onCreateCompleted.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.handleDownload = this.handleDownload.bind(this);
        
        this.state = {
            extractionPermissions: false,
            selectedType:'Entity',
            selected: null,
            selectedData: null,
            results: null,
            createEntity: false,
            createRegEx: false,
        }

        this.externalUrlsDisable = window._externalUrlsDisable;
    }

    componentDidMount() {
        const extractionPermissions = perms.checkEndpoint(urlHandler.API_ENDPOINT_V1_EXTRACTION);
        if (!extractionPermissions){
            history.push('/')
        } else{
            this.setState({extractionPermissions},()=> {
                if (this.state.extractionPermissions) {
                    this.onSearch(this.state.selectedType);
                }
            });
        }
    }

    onSelectResult(state, rowInfo, column, instance) {
        if (rowInfo) {
            if (rowInfo.index === this.state.selected) {
                return {
                    onClick: (e, handleOriginal) => {
                        this.setState({
                            selected: rowInfo.index,
                            selectedData: rowInfo.original,
                            selectedType: this.state.selectedType
                        })
                        if (handleOriginal) {
                            handleOriginal();
                        }
                    },
                    style: {
                        background: '#E9ECE0',
                        cursor: 'pointer'
                    }
                };
            } else {
                return {
                    onClick: (e, handleOriginal) => {
                        this.setState({
                            selected: rowInfo.index,
                            selectedData: rowInfo.original,
                            selectedType: this.state.selectedType
                        })
                        if (handleOriginal) {
                            handleOriginal();
                        }
                    },
                    style: {
                        cursor: 'pointer'
                    }
                };                
            }
    
        } else {
            return {}
        }
    }

    onResultsChange(selectedType, results) {
        this.setState({selectedType, results, selectedData:null, selected:null})
    }

    // onEdit(entity) {
    //     console.log(entity)
    //     if (entity) {

    //         // Update the edited entity in the current search results
    //         this.state.results.map((result)=> {
    //             var doc = result.document;
    //             if (doc.id == entity.id) {
    //                 doc.description = entity.description;
    //                 doc.label = entity.label;
    //                 doc.urls = entity.urls;
    //             }
    //         });

    //         this.setState({
    //             selectedData: null,
    //             selected: -1
    //         }) 
    //     }
    // }

    handleDownload() {
        const jsonData = JSON.stringify(this.state.results);
        const blob = new Blob([jsonData], { type: 'application/json' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = 'Custom_Entity_Entries.json';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

    }

    onCreate(e) {
        e.stopPropagation();
        const type = this.state.selectedType;
        this.setState({
            createEntity: type === 'Entity',
            createRegEx: type === 'RegEx',
        })
    }


    onCreateCompleted(cancelled=true) {
        if (cancelled){
            this.setState({
                createEntity:  false,
                createRegEx: false,
            })
        }else{
            this.setState({
                results: null,
                createEntity:  false,
                createRegEx: false,
            },()=>this.onSearch(this.state.selectedType))
        }
    }

    onDelete(resp=null) {
        this.setState({
            results: null,
            selectedData: null,
            selected: null,
        },()=>this.onSearch(this.state.selectedType)) 
    }

    onSearch(selectedType){
            // this.props.onChange(fakeResponse.entries);
            if(selectedType === 'Entity'){
                urlHandler.sendRequest('extraction', null, null, null, null, (response, arg1, status) => {
                    if (status != 200) {
                        console.log('Error calling sendRequest => ' + JSON.stringify(response));
                        this.setState({
                            selectedType,
                            selectedData:null,
                            selected:null,
                            processing: false,
                            error: response.error_message
                        });
                    } else {
                        this.onResultsChange(selectedType, response.entries)
    
                    }
                });
            }
            if(selectedType === 'RegEx'){
                urlHandler.sendRequest('regex', null, null, null, null, (response, arg1, status) => {
                    if (status != 200) {
                        console.log('Error calling sendRequest => ' + JSON.stringify(response));
                        this.setState({
                            selectedType,
                            processing: false,
                            error: response.error_message
                        });
                    } else {
                        this.onResultsChange(selectedType, response.entries)
    
                    }
                });
            }
        }

    // onClickUrl(url, e) {
    //     var win = window.open(url, '_blank');
    //     win.focus();
    //     e.stopPropagation();
    // }
    // columns = [
        //     {
        //     Header: 'Actions',
        //     width: 75,
        //     accessor: 'document.id', Cell: (row) => (
        //         <span>
        //             {this.state.extractionPermissions &&
        //                 <span className="fa fa-edit kbedit-invoke-link" title="Edit organization" onClick={() => {
        //                     kbEditOrganizationDialog(row.original.document.label, row.original.document.id, this.onEdit);
        //                 }}/>
        //             }
        //             {/* {this.state.kbPermissions.update && row.original.document.type === 'PERSON' &&
        //                 <span className="fa fa-edit kbedit-invoke-link" title="Edit person" onClick={() => {
        //                     kbEditPersonDialog(row.original.document.label, row.original.document.id, this.onEdit);
        //                 }}/>
        //             }
        //             {this.state.kbPermissions.update && !(row.original.document.type === 'ORGANIZATION' || row.original.document.type === 'PERSON') &&
        //                 <span className="fa fa-edit kbedit-invoke-link" title="Edit thing" onClick={() => {
        //                     kbEditThingDialog(row.original.document.label, row.original.document.id, this.onEdit);
        //                 }}/>
        //             } */}
        //             {this.state.extractionPermissions &&
        //                 <span className="fa fa-trash-o kbedit-invoke-link" title="Delete entity" onClick={() => {
        //                     kbDeleteDialog(row.original.document.type, row.original.document.label, row.original.document.id, this.onDelete);
        //                 }}/>
        //             }
        //         </span>
        //     ),
        //     show: this.state.extractionPermissions
        // }, 
        // {
        //     Header: 'Match Text',
        //     accessor: 'matchText', Cell: (row) => {
        //     console.log(row);
        //     return(
        //         <div>
        //         aonfoweifnaowefinwaoefinaweofnaweofn
        //         </div>
        //     )},
        //     width: 100
        // }, 
        // {
        //     Header: 'Id',
        //     accessor: 'document.id',
        //     width: 175
        // }, 
        // {
        //     Header: 'Label',
        //     accessor: 'document.label'
        // }, 
        // {
        //     Header: 'Urls',
        //     accessor: 'document.urls', Cell: (row) => (
        //         <div>
        //         {(row.original.document.urls && row.original.document.urls.length > 0) ?
        //             <div>
        //                 {row.original.document.urls.slice(0, 5).map((url, index) => {
        //                     if (this.externalUrlsDisable) {
        //                         return <div key={index}>{url}</div>
        //                     } else {
        //                         return <div key={index} onClick={this.onClickUrl.bind(this, url)} className="kbcontrol-link">{url}</div>
        //                     }
        //                 })}
        //             </div>
        //         :
        //             <div></div>
        //         }
        //         </div>
        //     ),
        //     show: !this.state.selectedData
        // }
    // ];

        // const lfColumns = [{
        //     Header: 'Id',
        //     accessor: 'id',
        //     width: 175
        // }, {
        //     Header: 'Label',
        //     accessor: 'label'
        // }, {
        //     Header: 'Feature',
        //     accessor: 'dsgFeatureCodeLabel',
        //     width: 175
        // },{
        //     Header: 'Admin1 Label',
        //     accessor: 'admin1Label',
        //     width: 175
        // },{
        //     Header: 'Admin2 Label',
        //     accessor: 'admin2Label',
        //     width: 200,
        //     show: !this.state.selectedData
        // },{
        //     Header: 'Country',
        //     accessor: 'countryLabel'
        // }];

    render() {
        return (
            <div className='kbcontrol-wrapper'>
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <span>
                                    <h1 className='heading-1' style={{float: 'left', marginBottom: '10px'}}>Custom Entities</h1>
                                    <span style={{float: 'right'}}>
                                        <a href={ UserManual } target="__blank" download="FFT_DemoUserManual.pdf"> 
                                            <span className='fa fa-file-pdf-o'>&nbsp;</span> 
                                            User Manual 
                                        </a> 
                                    </span>&nbsp;&nbsp;
                                    <span style={{float: 'right', marginRight: '25px'}}>
                                        <Link to={`/documentation/doc_custom${this.state.selectedType.toLowerCase()}#top`} className="list-link">
                                                <span className='fa fa-newspaper-o'>&nbsp;</span> 
                                                Custom {this.state.selectedType} Documentation
                                        </Link>
                                    </span>
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>
                                    <span className='form-label' style={{float: 'left', color:'#898989', fontSize:'16px', marginBottom: '40px'}}>Custom Entities/RegEx are used to help correctly extract entities from documents. Basic functionality is available with this interface, for full functionality use the FFT API.</span>
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td style={{width: '100%'}}>

                                                <span className="kb-query-wrapper">
                                                    <span className='kb-query-component form-field-wrapper text-field'>

                                                        <span className="form-field-wrapper" >
                                                            <select className='form-field create-selection' 
                                                            style={{'display':'inline', width:'125px', marginRight:'15px'}}
                                                            onChange={(e) => {
                                                                const value= e.target.value
                                                                    this.setState({results: null, selectedData:null, selected: null},()=> {
                                                                        this.onSearch(value);
                                                                    });
                                                                }}>
                                                                <option value="Entity">Entity</option>
                                                                <option value="RegEx">RegEx</option>
                                                            </select>
                                                        </span>
                                                    </span>
                                                    {/* <div className="kbcontrol-create-wrapper">
                                                        <button type="button" 
                                                            style={{textShadow:'1px 1px 0 rgba(0, 0, 0, 0.5)', fontSize:'17px'}}
                                                            className="kbcontrol-primary-button create-button" 
                                                            onClick={this.onCreate}>Create Custom {this.state.selectedType}
                                                        </button>
                                                        <CreateCustomEntity show={this.state.createEntity} onCreate={this.onCreateCompleted}/>
                                                        <CreateRegexEntity show={this.state.createRegEx} onCreate={this.onCreateCompleted}/>
                                                    </div> */}
                                                    {/* <div style={{marginTop:'5px'}}>
                                                        <FinchButton buttonClasses="kb-query-component query-button" 
                                                            inactive={this.state.inactive} 
                                                            processing={this.state.processing} 
                                                            primary={true} 
                                                            text={'Retrieve'}
                                                            submit={this.onSearch} />
                                                    </div> */}
                                                    <button type="button"
                                                        className="kbcontrol-primary-button create-button" 
                                                        disabled={!this.state.results || !this.state.results.length}
                                                        onClick={this.handleDownload}>Download Entries &nbsp;
                                                        <span className="fa fa-download"></span>
                                                    </button>
                            
                                                </span>

                                                {/* <button type="button" 
                                                    style={{textShadow:'1px 1px 0 rgba(0, 0, 0, 0.5)', fontSize:'17px', marginRight: '20px'}}
                                                    className="kbcontrol-primary-button create-button" 
                                                    inactive={this.state.inactive} 
                                                    processing={this.state.processing} 
                                                    primary={true} 
                                                    text={this.props.kbs && 'Retrieve'}
                                                    submit={this.onSearch} 
                                                    onClick={this.onCreate}>Retrieve
                                                </button> */}
                                            </td>
                                            <td>
                                            {this.state.extractionPermissions &&
                                                <div className="kbcontrol-create-wrapper" style={{marginBottom:'10px'}}>
                                                    <button type="button" 
                                                        style={{textShadow:'1px 1px 0 rgba(0, 0, 0, 0.5)', fontSize:'17px'}}
                                                        className="kbcontrol-primary-button create-button" 
                                                        onClick={this.onCreate}>Create Custom {this.state.selectedType}
                                                    </button>
                                                    <CreateCustomEntity show={this.state.createEntity} onCreate={this.onCreateCompleted}/>
                                                    <CreateRegexEntity show={this.state.createRegEx} onCreate={this.onCreateCompleted}/>
                                                </div>
                                            }
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
                {/* {(!this.state.results) && `Searching for ${this.state.selectedType}`}
                {(this.state.results && this.state.results.length === 0) && `No ${this.state.selectedType} Results Found`} */}

                    <div className="kbcontrol-results">
                        <span className="kbcontrol-list">
                                {/* <button type="button" style={{marginBottom:'10px'}}
                                    className="kbcontrol-primary-button create-button" 
                                    disabled={!this.state.results || !this.state.results.length}
                                    onClick={this.handleDownload}>Download Entries &nbsp;
                                    <span className="fa fa-download"></span>
                                </button>
                                &nbsp;&nbsp; */}
                            { (this.state.results && this.state.results.length === 0) &&
                                <div className="kbcontrol-no-results">
                                    No Results Found
                                </div>
                            } 

                            { (this.state.results && this.state.results.length > 0) && 
                            <ReactTable className="kb-table -striped" style={{marginRight:'5px'}}
                                data={this.state.results} 
                                resizeable={false}
                                columns={
                                    (this.state.selectedType === 'Entity') ? 
                                    [
                                        {
                                            Header: 'Actions',
                                            width: 75,
                                            accessor: 'matchText', 
                                            
                                            Cell: (row) => {
                                            return(
                                                <div style={{textAlign:'center'}}>
                                                    {this.state.extractionPermissions &&
                                                        <span className="fa fa-trash-o kbedit-invoke-link" title="Delete Entity" onClick={() => {
                                                            customEntityDeleteDialog(row.original.matchText, row.original.entityType, row.original.action, this.onDelete);
                                                        }}/>
                                                    }
                                                </div>
                                            )},
                                            show: this.state.extractionPermissions
                                        },

                                        {
                                            Header: 'Entity Type',
                                            accessor: 'entityType',
                                            width: 130,
                                        }, 
                                        {
                                            Header: 'Action' ,
                                            accessor: 'action',
                                            width: 130
                                        }, 
                                        {
                                            Header: 'Label',
                                            accessor: 'label',
                                            width: 250
                                        }, 
                                        {
                                            Header: 'Match Text',
                                            accessor: 'matchText',
                                        }, 
                                        
                                    ] : 
                                    [
                                        {
                                            Header: 'Actions',
                                            width: 75,
                                            accessor: 'patternName', 
                                            
                                            Cell: (row) => {
                                            return(
                                                <div style={{textAlign:'center'}}>
                                                    {this.state.extractionPermissions &&
                                                        <span className="fa fa-trash-o kbedit-invoke-link" title="Delete Entity" onClick={() => {
                                                            customRegExDeleteDialog(row.original.patternName, row.original.patternConfig.pattern, row.original.patternConfig.entityType, row.original.patternConfig.description, this.onDelete);
                                                        }}/>
                                                    }
                                                </div>
                                            )},
                                            show: this.state.extractionPermissions
                                        },
                                        {
                                            Header: 'Entity Type',
                                            accessor: 'patternConfig.entityType',
                                            width: 130,
                                        }, 
                                        {
                                            Header: 'Pattern Name',
                                            accessor: 'patternName',
                                            width: 130
                                        }, 
                                        {
                                            Header: 'Description',
                                            accessor: 'patternConfig.description',
                                            // width: 250,
                                        }
                                        
                                    ]

                                }
                                showPagination={false}
                                minRows={0}
                                // defaultPageSize={this.state.results.length+1}
                                getTdProps={this.onSelectResult}
                                />
                            }
                        </span>

                        {this.state.selectedData && this.state.selectedType === 'Entity' && 
                            <div>
                                <div className="kbcontrol-details-static">
                                    <CustomEntityDataControl
                                        permissions={this.state.extractionPermissions} 
                                        selectedData={this.state.selectedData}/>
                                </div>
                            </div>
                        }

                        {this.state.selectedData && this.state.selectedType === 'RegEx' && 
                            <div>
                                <div className="kbcontrol-details-static">
                                    <CustomRegExDataControl
                                        permissions={this.state.extractionPermissions} 
                                        selectedData={this.state.selectedData}/>
                                </div>
                            </div>
                        }
                    </div>
            </div>
        );
    }
}

export default KnowledgebaseControl;
